import icon from "../../assets/led.svg";
import type { Property } from "../../types";

export const etherlighting: Property = {
  id: "etherlighting",
  title: "etherlighting.title",
  icon,
  tooltip: "etherlighting.tooltip",
  tooltipWidth: 280,
};
